const userInitialState = {
    isLoggedIn: false,
    userDetails: {},
    token: "",
    isLoading: false,
    language: 'English',
    tempEmail: "",
    otpSendTime: "",
    isEmailVerified: false,
    isDarkMode:false
};
export default userInitialState;